import { render } from "./pageHeader.vue?vue&type=template&id=25d266ea"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Awamer work\\my projects\\Nuxt\\A new work\\saqf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__